import React from 'react';
import ReactDOM from 'react-dom/client';
import { App as AntdApp, ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { installCsrfFetch } from './utils/csrf';
import { FeedbackBridge } from './utils/feedback';
import { FrontErrorBoundary } from './components/FrontErrorBoundary';
import { installAssetLoadRecovery } from './utils/assetRecovery';
import { frontTheme, installFrontThemeCssVariables } from './theme';
import { applyFrontAppearance } from './utils/appearance';
import './styles.css';

if (typeof window !== 'undefined' && !window.requestIdleCallback) {
  window.requestIdleCallback = (callback) => {
    const start = Date.now();
    return window.setTimeout(() => {
      callback({
        didTimeout: false,
        timeRemaining: () => Math.max(0, 50 - (Date.now() - start))
      });
    }, 1);
  };
}

if (typeof window !== 'undefined' && !window.cancelIdleCallback) {
  window.cancelIdleCallback = (id) => window.clearTimeout(id);
}

installCsrfFetch();
installFrontThemeCssVariables();
applyFrontAppearance();
installAssetLoadRecovery();

const routerBasename = window.location.pathname === '/' ? '/' : '/front-v2';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN} theme={frontTheme}>
      <AntdApp>
        <FeedbackBridge />
        <FrontErrorBoundary>
          <BrowserRouter basename={routerBasename}>
            <App />
          </BrowserRouter>
        </FrontErrorBoundary>
      </AntdApp>
    </ConfigProvider>
  </React.StrictMode>
);
